import React from 'react';
import Radium from 'radium';
import {Container} from 'flux/utils';

import {A} from 'views/AppElements';
import HeaderContainer from 'containers/HeaderContainer';
import Footer from 'views/Footer';
import {Helmet} from "react-helmet";
import {Separator} from 'views/AppElements';

import ProductAPI from 'service/api/ProductAPI';
import ProductStore from 'stores/ProductStore';
import ProductList from 'views/product/ProductList';
import AppConstants from 'AppConstants';
import SearchInput from 'views/SearchInput';

class SearchResultPage extends React.Component {
    static getStores() {
		return [ProductStore];
	}

	static calculateState(prevState, props) {
        const keyword = SearchResultPage.fetchSearchKeyword(props);

		let newState = {
				products: ProductStore.getSearchProducts(keyword),
			};
		return newState;
    }

    static fetchSearchKeyword(props) {
		const keyword = props.match.params.keyword;
		return keyword? keyword: '';
    }
    
    componentDidMount() {
        const keyword = SearchResultPage.fetchSearchKeyword(this.props);

        if (this.state.products === null)
            ProductAPI.searchProducts(keyword);
    }

    componentDidUpdate(prevProps) {
        const prevKeyword = SearchResultPage.fetchSearchKeyword(prevProps);
        const currentKeyword = SearchResultPage.fetchSearchKeyword(this.props);

        if(prevKeyword.toLowerCase() !== currentKeyword.toLowerCase()) {
			if(!ProductStore.getSearchProducts(currentKeyword))
                ProductAPI.searchProducts(currentKeyword);
		}
    }

    getEmptyMsg(keyword) {
        const words = keyword.split(" ");

        let eachWordSearch = null;
        if(words.length > 1) {
            eachWordSearch = <span>Try searching for {words.map(w => <span><A href={"/search/"+w}>'{w}'</A>, </span>)}</span>
        } else {
            eachWordSearch = <span>Try using other words</span>
        }
        return <small>Nothing found. {eachWordSearch}<br /> <small>OR</small> <br /><small><A href="https://m.me/setocanvas.com">DM US</A> to help you find it.</small></small>;
    }
    
	render() {
        const keyword = SearchResultPage.fetchSearchKeyword(this.props);

        const emptyMsg = this.getEmptyMsg(keyword);
        const popularTags = AppConstants.TOP_TAGS.map(t => <span key={"search_tag_"+t.name} className="tags"><A href={"/search/"+t.name}>{t.value}</A></span>);
		return (<div id="searchResultPage">
                    <Helmet>
						<title>{keyword.toUpperCase()} Search Results | Seto Canvas</title>
    					<meta name="description" content={"Purchase T-Shirts, Sweatshirts, Hoodies and many more at SetoCanvas.com"} />
					</Helmet>
			        <HeaderContainer />
			        
                    <div className="mainContainer">
                        <SearchInput keyword={keyword} title="SEARCH FROM 1,000+ UNIQUE SELECTIONS" />
                        <div className="searchResTags flexRow">
							{popularTags}
						</div>

                        {keyword && 
                            <div>
                                <Separator style={{margin: '40px auto 20px auto'}} />
                                <ProductList products={this.state.products} 
                                        flattenProductImages={true} 
                                        viewProductTags={true} 
                                        emptyMsg={emptyMsg}/>
                            </div>
                        }
                        
                    </div>
			        <Footer />
		      	</div>
			);
		
	}
}

export default Radium(Container.create(SearchResultPage, {withProps: true}));


// WEBPACK FOOTER //
// ./src/pages/SearchResultPage.js